var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"删除中","name":"first"}},[_c('order-exception-applying')],1),_c('el-tab-pane',{attrs:{"label":"已删除","name":"second"}},[_c('order-exception-approved')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }